import { drop } from 'lodash';

export function getPaginatedItems<T>(
  items: T[],
  page: number,
  pageSize: number
) {
  const pg = page || 1;
  const pgSize = pageSize || 100;
  const offset = (pg - 1) * pgSize;
  const pagedItems = drop(items, offset).slice(0, pgSize);
  return {
    page: pg,
    pageSize: pgSize,
    total: items.length,
    totalPages: Math.ceil(items.length / pgSize),
    data: pagedItems,
  };
}
